// libs
import React from 'react';
import { styled } from '@nykaa/ui-components';

// components
import WidgetItem from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/components/WidgetItem';
import ProductContainer from 'components/AdPlatformWidgets/components/ProductContainer';

// constants
import { CAROUSEL_TYPES } from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/constants';

// defs
import { IProduct, IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

// helpers
import { getPlaceHolderColor } from 'shared/components/AdPlatformWidgets/helpers';

// defs
interface IWidgetList {
  widgetType: number;
  widgets: IWidgetItems[] | IProduct[];
  widgetWidth: number;
  contentAlign: string;
  inventoryName: string;
}

const CustomProduct = styled(ProductContainer)`
  padding: 20px 0;
  margin-top: 10px;
`;

export default function WidgetList({
  widgetType,
  widgets,
  widgetWidth,
  contentAlign,
  inventoryName = '',
}: IWidgetList) {
  if (widgetType === CAROUSEL_TYPES.PRODUCTS) {
    return widgets.map((product) => (
      <CustomProduct width={widgetWidth} key={product.id} item={product} />
    ));
  }

  if (widgetType === CAROUSEL_TYPES.WIDGETS) {
    return widgets.map((widget, id) => {
      const placeholderColor = getPlaceHolderColor(id);
      return (
        <WidgetItem
          key={id}
          widget={widget}
          width={widgetWidth}
          inventoryName={inventoryName}
          placeholderColor={placeholderColor}
          contentAlign={contentAlign}
        />
      );
    });
  }
}
